// 风控告警 PDF 报告模板 —— 生成可打印(另存为 PDF)的独立 HTML 文档。
// 纯字符串拼装，零依赖；由 costAlerts.vue 的导出方法调用后写入新窗口打印。

function esc(v) {
  if (v == null) return ''
  return String(v)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;')
}

function fmt(n, d = 0) {
  const x = Number(n)
  if (!isFinite(x)) return '0'
  return x.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d })
}

const SEV = {
  critical: { label: '严重', cls: 'red' },
  warning: { label: '警告', cls: 'amber' },
  info: { label: '提示', cls: 'blue' },
  ok: { label: '正常', cls: 'green' },
}
function sevBadge(s) {
  const c = SEV[s] || { label: s || '—', cls: 'grey' }
  return `<span class="badge ${c.cls}"><span class="d"></span>${esc(c.label)}</span>`
}

function delta(pct) {
  const v = Number(pct) || 0
  const cls = v >= 0 ? 'delta-up' : 'delta-down'
  const sign = v >= 0 ? '+' : '−'
  return `<span class="${cls}">${sign}${fmt(Math.abs(v), 1)}%</span>`
}

function donut(mix) {
  const c = Number(mix.critical || 0), w = Number(mix.warning || 0), i = Number(mix.info || 0)
  const total = c + w + i
  if (!total) {
    return `<div class="donut-wrap"><div class="donut empty"><div class="center"><div><div class="big">0</div><div class="lbl">无告警</div></div></div></div></div>`
  }
  const cp = c / total * 100, wp = w / total * 100
  const g = `conic-gradient(var(--sev-crit) 0 ${cp}%, var(--sev-warn) ${cp}% ${cp + wp}%, var(--sev-info) ${cp + wp}% 100%)`
  return `
    <div class="donut-wrap">
      <div class="donut" style="background:${g}"><div class="center"><div><div class="big">${total}</div><div class="lbl">告警总数</div></div></div></div>
      <div class="legend">
        <div class="li"><span class="sw" style="background:var(--sev-crit)"></span>严重 <span class="val">${c}</span></div>
        <div class="li"><span class="sw" style="background:var(--sev-warn)"></span>警告 <span class="val">${w}</span></div>
        <div class="li"><span class="sw" style="background:var(--sev-info)"></span>提示 <span class="val">${i}</span></div>
      </div>
    </div>`
}

function partnerBars(bars) {
  if (!bars || !bars.length) return '<div class="muted">本期无费用异常数据</div>'
  return `<div class="stackrow">` + bars.map(b => `
    <div class="sr">
      <span class="nm"><span class="dot" style="background:${b.color}"></span>${esc(b.name)}</span>
      <span class="track"><span class="seg" style="width:${b.pct}%;background:${b.color}"></span></span>
      <span class="amt">${fmt(b.value)}</span>
    </div>`).join('') + `</div>`
}

function aiSection(ai, riskText) {
  if (!ai || (!ai.summary && !ai.raw)) {
    return `<div class="ai-note-empty">尚未生成 AI 研判。可先在风控告警页点击「生成 AI 研判」，再导出报告即可包含 AI 分析。</div>`
  }
  const riskCls = { high: 'r-high', medium: 'r-mid', low: 'r-low' }[ai.riskLevel] || ''
  const body = ai.summary ? `<div class="ai-body">${esc(ai.summary)}</div>` : `<div class="ai-body raw">${esc(ai.raw)}</div>`
  let chips = ''
  if (ai.riskLevel || (ai.verdicts && ai.verdicts.length)) {
    chips = `<div class="ai-verdict">`
    if (ai.riskLevel) chips += `<span class="ai-chip">整体风险等级：<b class="${riskCls}">${esc(riskText || ai.riskLevel)}</b></span>`
    ;(ai.verdicts || []).forEach(v => { chips += `<span class="ai-chip">${esc(v.label)}：<b>${esc(v.value)}</b></span>` })
    chips += `</div>`
  }
  let recs = ''
  if (ai.recommendations && ai.recommendations.length) {
    recs = `<ul class="ai-recs">` + ai.recommendations.map(r => `<li>${esc(r)}</li>`).join('') + `</ul>`
  }
  return `${body}${chips}${recs}<div class="ai-note">* 由 GPT-5.5 基于本期指标生成，仅供风控参考，最终以人工复核为准。</div>`
}

function anomalyTable(rows) {
  if (!rows || !rows.length) return '<div class="empty">本期无费用异常告警</div>'
  return `<table><thead><tr>
    <th>Link</th><th>伙伴</th><th>类型</th><th>严重度</th>
    <th class="r">上月 (USD)</th><th class="r">本月 (USD)</th><th class="r">环比</th>
  </tr></thead><tbody>` + rows.map(a => `
    <tr>
      <td><div class="rname">${esc(a.linkName)}</div><div class="rsub">${esc(a.linkId)}</div></td>
      <td>${esc((a.partnerName || '').split(' ')[0] || '—')}</td>
      <td>${a.type === 'drop' ? '<span class="badge green"><span class="d"></span>下降</span>' : '<span class="badge red"><span class="d"></span>激增</span>'}</td>
      <td>${sevBadge(a.severity)}</td>
      <td class="r num">${fmt(a.previousSpend)}</td>
      <td class="r num">${fmt(a.currentSpend)}</td>
      <td class="r num">${delta(a.changePercent)}</td>
    </tr>`).join('') + `</tbody></table>`
}

function instanceTable(rows) {
  if (!rows || !rows.length) return '<div class="empty">本期无大实例</div>'
  return `<table><thead><tr>
    <th>实例规格</th><th>Link / 伙伴</th><th>状态</th><th>首现月份</th><th>严重度</th>
    <th style="min-width:150px">月成本占比</th><th class="r">月成本 (USD)</th>
  </tr></thead><tbody>` + rows.map(i => `
    <tr>
      <td><span class="code">${esc(i.instanceType)}</span></td>
      <td><div class="rname">${esc(i.linkName)}</div><div class="rsub">${esc((i.partnerName || '').split(' ')[0])}</div></td>
      <td>${i.status === 'new' ? '<span class="badge blue"><span class="d"></span>新开通</span>' : '<span class="badge green"><span class="d"></span>持续运行</span>'}</td>
      <td class="num">${esc(i.launchTime || '—')}</td>
      <td>${sevBadge(i.severity)}</td>
      <td><div class="barcell"><div class="track"><div class="fill" style="width:${i.pct}%;background:${i.severity === 'critical' ? 'var(--sev-crit)' : i.severity === 'warning' ? 'var(--sev-warn)' : 'var(--sev-info)'}"></div></div><span class="pct num">${i.pct}%</span></div></td>
      <td class="r num">${fmt(i.estimatedMonthlyCost)}</td>
    </tr>`).join('') + `</tbody></table>`
}

function freqTable(rows) {
  if (!rows || !rows.length) return '<div class="empty">本期无账号频繁进出告警</div>'
  return `<table><thead><tr>
    <th>Payer / 伙伴</th><th>严重度</th>
    <th class="r">Link 总数</th><th class="r">短命数</th><th class="r">短命占比</th>
    <th class="r">平均寿命</th><th class="r">单月峰值</th><th>爆发月</th>
  </tr></thead><tbody>` + rows.map(p => `
    <tr>
      <td><div class="rname">${esc(p.payerName)}</div><div class="rsub">${esc((p.partnerName || '').split(' ')[0])}</div></td>
      <td>${sevBadge(p.severity)}</td>
      <td class="r num">${fmt(p.totalLinks)}</td>
      <td class="r num">${fmt(p.shortLived)}</td>
      <td class="r num">${Math.round((p.shortRatio || 0) * 100)}%</td>
      <td class="r num">${fmt(p.avgLifespan, 1)} 月</td>
      <td class="r num">${fmt(p.maxMonthlyChurn)}</td>
      <td><span class="code">${esc(p.burstMonth || '—')}</span></td>
    </tr>`).join('') + `</tbody></table>`
}

function pipeline(step, steps) {
  return `<div class="pipeline">` + steps.map((s, i) => {
    const cls = i < step ? 'done' : (i === step ? 'active' : '')
    return `<div class="step ${cls}">${esc(s)}</div>`
  }).join('') + `</div>`
}

function billTable(rows, steps) {
  if (!rows || !rows.length) return '<div class="empty">本期无账单记录</div>'
  return `<table><thead><tr>
    <th>Link / 伙伴</th><th style="min-width:320px">流转进度</th>
    <th class="r">计费 (USD)</th><th class="r">成本 (USD)</th>
  </tr></thead><tbody>` + rows.map(b => `
    <tr>
      <td><div class="rname">${esc(b.linkName || '—')}</div><div class="rsub">${esc((b.partnerName || '').split(' ')[0])}</div></td>
      <td>${pipeline(b.step, steps)}</td>
      <td class="r num">${fmt(b.charge, 2)}</td>
      <td class="r num">${fmt(b.cost, 2)}</td>
    </tr>`).join('') + `</tbody></table>`
}

export function buildReportHtml(p) {
  const m = p.meta || {}
  const kpi = p.kpi || {}
  return `<!DOCTYPE html>
<html lang="zh-CN"><head><meta charset="UTF-8" />
<title>风控告警报告 ${esc(m.monthLabel || '')}</title>
<style>
  :root{
    --page-bg:#f2f3f3;--container:#fff;--ink-title:#16191f;--ink-body:#414d5c;--ink-sec:#5f6b7a;--ink-mute:#879596;
    --border:#e9ebed;--border-2:#d5dbdb;--blue:#0972d3;--nav:#232f3e;
    --red:#d91515;--red-bg:#fff7f7;--red-bd:#ffcfcf;--amber:#8d6605;--amber-bg:#fffbf0;--amber-bd:#ffe08a;
    --green:#037f0c;--green-bg:#f2fcf3;--green-bd:#b7e1b9;--grey:#5f6b7a;--grey-bg:#f4f4f4;--grey-bd:#d5dbdb;
    --info:#0972d3;--info-bg:#f0f8ff;--info-bd:#b8dcff;--q1:#7d3ff2;--q2:#4b6ef5;
    --cat-1:#8456ce;--cat-2:#2ea597;--cat-3:#e07941;--cat-4:#688ae8;
    --sev-crit:#c33d69;--sev-warn:#e07941;--sev-info:#688ae8;
  }
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:"Amazon Ember",-apple-system,BlinkMacSystemFont,"PingFang SC","Microsoft YaHei","Segoe UI",Roboto,Arial,sans-serif;background:var(--page-bg);color:var(--ink-body);-webkit-font-smoothing:antialiased;font-size:13px;line-height:1.5;-webkit-print-color-adjust:exact;print-color-adjust:exact}
  .num{font-variant-numeric:tabular-nums}
  .wrap{max-width:1180px;margin:0 auto;padding:24px 26px 60px}
  .toolbar{display:flex;justify-content:flex-end;gap:10px;margin-bottom:14px}
  .btn{height:34px;padding:0 16px;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;border:1px solid var(--border-2);background:#fff;color:var(--ink-title)}
  .btn.primary{background:var(--blue);border-color:var(--blue);color:#fff}
  .cover{position:relative;overflow:hidden;border-radius:14px;padding:26px 30px;color:#fff;margin-bottom:18px;background:linear-gradient(135deg,#232f3e,#31465f)}
  .cover .eyebrow{font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#ff9900;font-weight:700}
  .cover h1{font-size:26px;font-weight:800;margin:8px 0 4px}
  .cover .sub{font-size:13px;color:#c9d3e0}
  .filterbar{display:flex;align-items:center;gap:22px;flex-wrap:wrap;background:var(--container);border:1px solid var(--border);border-radius:12px;padding:14px 18px;margin-bottom:18px}
  .filterbar .flabel{font-size:11px;color:var(--ink-sec);font-weight:700;text-transform:uppercase;letter-spacing:.03em}
  .filterbar .fval{font-size:14px;color:var(--ink-title);font-weight:600;margin-top:3px}
  .filterbar .fval .range{color:var(--blue)}
  .vsep{width:1px;align-self:stretch;background:var(--border-2)}
  .ai-panel{border-radius:12px;padding:1px;background:linear-gradient(120deg,var(--q1),var(--q2));margin-bottom:18px}
  .ai-inner{background:linear-gradient(180deg,#fbfaff,#fff);border-radius:11px;padding:18px 20px}
  .ai-head{display:flex;align-items:center;gap:10px;margin-bottom:12px}
  .ai-spark{width:28px;height:28px;border-radius:8px;background:linear-gradient(135deg,var(--q1),var(--q2));display:grid;place-items:center;color:#fff;font-size:15px}
  .ai-title{font-size:15px;font-weight:700;color:var(--ink-title)}
  .ai-badge{font-size:11px;font-weight:700;color:var(--q1);background:#f3edff;border:1px solid #e0d0ff;padding:2px 9px;border-radius:20px}
  .ai-body{font-size:13.5px;color:var(--ink-body);line-height:1.75}
  .ai-body.raw{white-space:pre-wrap}
  .ai-verdict{display:flex;gap:10px;margin-top:14px;flex-wrap:wrap}
  .ai-chip{font-size:12px;font-weight:600;padding:5px 12px;border-radius:8px;background:#fff;border:1px solid var(--border-2);color:var(--ink-body)}
  .ai-chip .r-high{color:var(--red)}.ai-chip .r-mid{color:var(--amber)}.ai-chip .r-low{color:var(--green)}
  .ai-recs{margin:12px 0 0;padding-left:20px;font-size:13px;color:var(--ink-body);line-height:1.8}
  .ai-note{margin-top:12px;font-size:12px;color:var(--ink-mute);font-style:italic}
  .ai-note-empty{font-size:13px;color:var(--ink-sec)}
  .kpis{display:grid;grid-template-columns:repeat(5,1fr);gap:14px;margin-bottom:18px}
  .kpi{background:var(--container);border:1px solid var(--border);border-radius:12px;padding:16px 18px;position:relative;overflow:hidden}
  .kpi::before{content:"";position:absolute;left:0;top:0;bottom:0;width:4px}
  .kpi.k-red{background:linear-gradient(135deg,#fdeff0,#fff 60%)}.kpi.k-red::before{background:var(--sev-crit)}.kpi.k-red .num{color:var(--sev-crit)}
  .kpi.k-amber{background:linear-gradient(135deg,#fdf3e9,#fff 60%)}.kpi.k-amber::before{background:var(--sev-warn)}.kpi.k-amber .num{color:var(--sev-warn)}
  .kpi.k-blue{background:linear-gradient(135deg,#eef3fd,#fff 60%)}.kpi.k-blue::before{background:var(--cat-4)}.kpi.k-blue .num{color:var(--cat-4)}
  .kpi.k-purple{background:linear-gradient(135deg,#f4eefb,#fff 60%)}.kpi.k-purple::before{background:var(--cat-1)}.kpi.k-purple .num{color:var(--cat-1)}
  .kpi.k-teal{background:linear-gradient(135deg,#e9f6f3,#fff 60%)}.kpi.k-teal::before{background:var(--cat-2)}.kpi.k-teal .num{color:var(--cat-2)}
  .kpi .klabel{font-size:12px;color:var(--ink-sec);font-weight:600;margin-bottom:10px}
  .kpi .num{font-size:30px;font-weight:800;color:var(--ink-title);line-height:1}
  .viz-row{display:grid;grid-template-columns:1fr 1.5fr;gap:16px;margin-bottom:18px}
  .card{background:var(--container);border:1px solid var(--border);border-radius:12px;padding:16px 18px}
  .card .ctitle{font-size:14px;font-weight:700;color:var(--ink-title);margin-bottom:2px}
  .card .csub{font-size:12px;color:var(--ink-sec);margin-bottom:14px}
  .donut-wrap{display:flex;align-items:center;gap:18px}
  .donut{width:112px;height:112px;border-radius:50%;position:relative;flex-shrink:0}
  .donut.empty{background:#eceef0}
  .donut::after{content:"";position:absolute;inset:16px;background:#fff;border-radius:50%}
  .donut .center{position:absolute;inset:0;display:grid;place-items:center;text-align:center}
  .donut .center .big{font-size:23px;font-weight:800;color:var(--ink-title);line-height:1}
  .donut .center .lbl{font-size:10px;color:var(--ink-sec)}
  .legend{display:flex;flex-direction:column;gap:8px}
  .legend .li{display:flex;align-items:center;gap:8px;font-size:12.5px;color:var(--ink-body)}
  .legend .sw{width:10px;height:10px;border-radius:3px}
  .legend .val{margin-left:auto;font-weight:700;color:var(--ink-title)}
  .stackrow{display:flex;flex-direction:column;gap:12px}
  .stackrow .sr{display:grid;grid-template-columns:96px 1fr 78px;align-items:center;gap:10px}
  .stackrow .sr .nm{font-size:12.5px;font-weight:600;color:var(--ink-body);display:flex;align-items:center;gap:6px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}
  .stackrow .sr .nm .dot{width:9px;height:9px;border-radius:3px;flex-shrink:0}
  .stackrow .sr .track{height:18px;background:#f4f4f4;border-radius:5px;overflow:hidden}
  .stackrow .sr .track .seg{height:100%}
  .stackrow .sr .amt{text-align:right;font-size:12.5px;font-weight:700;color:var(--ink-title)}
  .container{background:var(--container);border:1px solid var(--border);border-radius:12px;margin-bottom:18px;overflow:hidden}
  .chead{display:flex;align-items:center;gap:10px;padding:15px 20px;border-bottom:1px solid var(--border)}
  .chead .idx{width:26px;height:26px;border-radius:7px;background:#fff3e0;border:1px solid #ffd9a8;color:#b7791f;display:grid;place-items:center;font-weight:800;font-size:13px}
  .chead h2{font-size:15px;font-weight:700;color:var(--ink-title)}
  .chead .cnt{font-size:12px;color:var(--ink-sec)}
  table{width:100%;border-collapse:collapse;font-size:12.5px}
  thead th{text-align:left;font-weight:700;color:var(--ink-sec);font-size:11px;padding:10px 20px;background:#fafafa;border-bottom:1px solid var(--border);white-space:nowrap}
  thead th.r{text-align:right}
  tbody td{padding:11px 20px;border-bottom:1px solid #f0f1f2;color:var(--ink-body);vertical-align:middle}
  tbody td.r{text-align:right}
  tbody td.num{font-variant-numeric:tabular-nums}
  tbody tr:last-child td{border-bottom:none}
  td.num.r{font-weight:700;color:var(--ink-title)}
  .badge{display:inline-flex;align-items:center;gap:5px;padding:2px 9px;border-radius:4px;font-size:12px;font-weight:700;white-space:nowrap;border:1px solid transparent}
  .badge .d{width:6px;height:6px;border-radius:50%}
  .badge.red{background:var(--red-bg);color:var(--red);border-color:var(--red-bd)}.badge.red .d{background:var(--red)}
  .badge.amber{background:var(--amber-bg);color:var(--amber);border-color:var(--amber-bd)}.badge.amber .d{background:var(--amber)}
  .badge.green{background:var(--green-bg);color:var(--green);border-color:var(--green-bd)}.badge.green .d{background:var(--green)}
  .badge.blue{background:var(--info-bg);color:var(--info);border-color:var(--info-bd)}.badge.blue .d{background:var(--info)}
  .badge.grey{background:var(--grey-bg);color:var(--grey);border-color:var(--grey-bd)}
  .code{font-family:"SF Mono","Consolas",monospace;font-size:12px;background:#f4f4f4;border:1px solid var(--border-2);border-radius:4px;padding:1px 6px;color:var(--ink-title)}
  .delta-up{color:var(--red);font-weight:700}.delta-down{color:var(--green);font-weight:700}
  .rname{font-weight:700;color:var(--ink-title)}
  .rsub{font-size:11px;color:var(--ink-mute);font-family:"SF Mono","Consolas",monospace;margin-top:2px}
  .barcell{display:flex;align-items:center;gap:8px}
  .barcell .track{flex:1;height:6px;background:#eceef0;border-radius:4px;overflow:hidden;min-width:60px}
  .barcell .fill{height:100%;border-radius:4px}
  .barcell .pct{color:var(--ink-sec);font-size:11px;min-width:28px}
  .pipeline{display:flex;align-items:center;gap:4px}
  .pipeline .step{flex:1;text-align:center;font-size:11px;padding:6px 4px;border-radius:4px;background:#f4f4f4;color:var(--ink-mute);border:1px solid var(--border)}
  .pipeline .step.done{background:var(--green-bg);color:var(--green);font-weight:700;border-color:var(--green-bd)}
  .pipeline .step.active{background:var(--blue);color:#fff;font-weight:700;border-color:var(--blue)}
  .empty,.muted{padding:18px 20px;font-size:13px;color:var(--ink-mute)}
  .footer{margin-top:26px;padding-top:16px;border-top:1px solid var(--border-2);display:flex;justify-content:space-between;font-size:12px;color:var(--ink-mute)}
  @media print{.toolbar{display:none}.container,.kpi,.ai-panel,.filterbar,.card,.cover{break-inside:avoid}}
</style></head>
<body>
<div class="wrap">
  <div class="toolbar">
    <button class="btn primary" onclick="window.print()">保存为 PDF / 打印</button>
    <button class="btn" onclick="window.close()">关闭</button>
  </div>

  <div class="cover">
    <div class="eyebrow">RISK CONTROL · MONTHLY REPORT</div>
    <h1>风控告警月度报告</h1>
    <div class="sub">账单月 ${esc(m.monthLabel || '—')} · 本期告警 ${fmt(m.alertCount || 0)} 项 · 覆盖伙伴 ${fmt(m.partnerCount || 0)} 家</div>
  </div>

  <div class="filterbar">
    <div><div class="flabel">账单月</div><div class="fval"><span class="range">${esc(m.monthLabel || '—')}</span></div></div>
    <div class="vsep"></div>
    <div><div class="flabel">生成时间</div><div class="fval num">${esc(m.genAt || '')}</div></div>
    <div class="vsep"></div>
    <div><div class="flabel">汇率折算</div><div class="fval">CN Payer ÷ 7.225 → USD</div></div>
    <div class="vsep"></div>
    <div><div class="flabel">数据口径</div><div class="fval">最新完整账单月</div></div>
  </div>

  <div class="ai-panel"><div class="ai-inner">
    <div class="ai-head">
      <span class="ai-spark">✦</span><span class="ai-title">AI 风控研判</span><span class="ai-badge">GPT-5.5</span>
    </div>
    ${aiSection(p.ai, p.aiRiskText)}
  </div></div>

  <div class="kpis">
    <div class="kpi k-red"><div class="klabel">严重告警</div><div class="num">${fmt(kpi.critical)}</div></div>
    <div class="kpi k-amber"><div class="klabel">警告</div><div class="num">${fmt(kpi.warning)}</div></div>
    <div class="kpi k-blue"><div class="klabel">新增大实例</div><div class="num">${fmt(kpi.newInstances)}</div></div>
    <div class="kpi k-purple"><div class="klabel">待处理账单</div><div class="num">${fmt(kpi.pendingBills)}</div></div>
    <div class="kpi k-teal"><div class="klabel">频繁变更账号</div><div class="num">${fmt(kpi.frequentChurn)}</div></div>
  </div>

  <div class="viz-row">
    <div class="card"><div class="ctitle">告警严重度构成</div><div class="csub">本期费用异常告警</div>${donut(p.severityMix || {})}</div>
    <div class="card"><div class="ctitle">按伙伴异常费用分布</div><div class="csub">本月异常 Link 费用合计 (USD)</div>${partnerBars(p.partnerBars)}</div>
  </div>

  <div class="container">
    <div class="chead"><span class="idx">1</span><h2>费用异常</h2><span class="cnt">Top ${(p.anomalies || []).length}</span></div>
    ${anomalyTable(p.anomalies)}
  </div>
  <div class="container">
    <div class="chead"><span class="idx">2</span><h2>大实例开通</h2><span class="cnt">Top ${(p.instances || []).length}</span></div>
    ${instanceTable(p.instances)}
  </div>
  <div class="container">
    <div class="chead"><span class="idx">3</span><h2>账号频繁进出</h2><span class="cnt">Top ${(p.freq || []).length}</span></div>
    ${freqTable(p.freq)}
  </div>
  <div class="container">
    <div class="chead"><span class="idx">4</span><h2>账单生命周期</h2><span class="cnt">Top ${(p.bills || []).length}</span></div>
    ${billTable(p.bills, p.steps || [])}
  </div>

  <div class="footer">
    <span>账单平台 · 风控告警自动报告</span>
    <span>阈值：费用异常 &gt;30% / &gt;50% / &gt;100% · 大实例 &gt;$1K / &gt;$5K · 频繁变更四因子</span>
  </div>
</div>
<script>window.addEventListener('load',function(){setTimeout(function(){try{window.print()}catch(e){}},400)})</script>
</body></html>`
}
